try {
    $(document).ready( function () {
        var commentInnerGrid = $('.comments__inner__grid');
        $('#show-more-comments-btn').click(function () {

            if ($('.comments__inner__grid__el').length > 1) {
                commentInnerGrid.css('max-height', '9999px');
                $('#show-more-comments-btn').hide();
            } else {
                alert('Brak komentarzy!');
            }
        });

        setTimeout(function(){
            if ($('.comments__inner__grid__el').length === 0) {
                $('#show-more-comments-btn').hide();
            }
        }, 1500);
    });
} catch (error) {
    console.error(error);
}

